import React, {FC} from "react";
import {Address} from "../redux/types";
import Typography from "@material-ui/core/Typography";
import {Grid, TextField, Tooltip} from "@material-ui/core";
import {FormikSalutationSelect} from "../sharedComponents/FormikSalutationSelect";
import {FormikTextField} from "../form/FormikTextField";
import {InfoOutlined} from "@material-ui/icons";
import {FormikDcbAddressInput} from "../sharedComponents/DcbAddressInput";
import {useField} from "formik";

interface OrderAddressFormProps {
    /*  initialEmail: string;
      initialValues: OrderAddress;
      onSubmit: (values: { address: OrderAddress; email: string }) => void;*/
    withEmail?: boolean,
    staticAddress?: Address;
    label: string;
    prefix: "serviceAddress" | "invoiceAddress",
    toolTip: string;
}

export const OrderAddressForm: FC<OrderAddressFormProps> = ({withEmail, staticAddress, label, prefix, toolTip}) => {
    const [,meta] = useField<Address>(prefix + ".address");

    return (
        <div>
            <Typography style={{display: "inline-flex", alignItems: "center", marginBottom: 8}} color="textSecondary">
                {label}
                <Tooltip title={toolTip} style={{marginLeft: 4}}>
                    <InfoOutlined color="inherit" fontSize="inherit"/>
                </Tooltip>
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <FormikSalutationSelect prefix={prefix + ".name"}/>
                </Grid>
                <Grid item xs={6} sm={4}>
                    <FormikTextField withoutTouched fullWidth name={prefix + ".name.firstName"} label="Vorname"
                                     required/>
                </Grid>
                <Grid item xs={6} sm={4}>
                    <FormikTextField withoutTouched fullWidth name={prefix + ".name.lastName"} label="Nachname"
                                     required/>
                </Grid>
                <Grid item xs={12}>
                    {staticAddress
                        ? (
                            <TextField
                                disabled={Boolean(staticAddress)}
                                label="Addresse"
                                fullWidth
                                value={staticAddress.formattedAddress}/>
                        )
                        : (
                            <FormikDcbAddressInput
                                name={prefix + ".address"}
                                label={prefix === "invoiceAddress" ? "Rechnungsadresse" : "Auftragsadresse"}
                                textFieldProps={{
                                    required: true,
                                    error: Boolean(meta.error),
                                    // @ts-ignore
                                    helperText: meta.error?.formattedAddress
                                }}
                            />
                        )
                    }
                </Grid>
                {withEmail && (
                    <Grid item xs={12} sm={6}>
                        <FormikTextField fullWidth name={"email"} label="E-Mail" required/>
                    </Grid>
                )}
                <Grid item xs={12} sm={6}>
                    <FormikTextField withoutTouched fullWidth name={prefix + ".phone"} label="Telefon" required/>
                </Grid>
                <Grid item xs={12}>
                    <FormikTextField fullWidth name={prefix + ".name.company"} label="Firma"/>
                </Grid>
            </Grid>
        </div>
    )
}
